var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "16px",
    viewBox: "0 0 23 16",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "9E541DDF-54BC-4710-8526-AB5891DACAD0")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-V10",
    transform: "translate(-231.000000, -7850.000000)",
    stroke: "#283580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-arrow",
    transform: "translate(242.500000, 7858.000000) rotate(-270.000000) translate(-242.500000, -7858.000000) translate(234.000000, 7847.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3058,20.7683 L8.3058,0.5003",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "16.1115 13.3952 8.3055 21.2012 0.4995 13.3952"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/left-arrow.91fcb1bd.svg";
export { ForwardRef as ReactComponent };